











import {defineComponent, PropType, ref} from "@vue/composition-api";
import AppLayout from "@tool/Layouts/AppLayout.vue";
import Todo from "@tool/Components/Todo.vue";
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import {CrumbPage, TeamEntityInterface} from "@tool/tool.types";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";


export default defineComponent({
    components: {
        Breadcrumbs,
        Todo,
        AppLayout,
        ThemeBlock
    },
    props: {
        team: {
            type: Object as PropType<TeamEntityInterface>,
            required: true
        },
    },
    setup(props, {slots}) {

        const tabItemsSetup: { name: string; routeName: string }[] = [
            {name: 'Projects', routeName: 'app.team.projects.index'},
            {name: 'Settings & Members', routeName: 'app.team.settings.index'},
            {name: 'Billing', routeName: 'app.team.billing.index'},
        ];

        const pageName = ref('');

        const tabItems = tabItemsSetup.map(item => {
            const isCurrent = route().current(item.routeName);

            if (isCurrent) {
                pageName.value = item.name;
            }

            return {
                name: item.name,
                classes: {
                    active: isCurrent,
                    'nav-link': true
                },
                href: route(item.routeName, props.team.id),
            }
        });

        const breadcrumbPages: CrumbPage[] = [
            {name: pageName.value}
        ];

        return {
            pageName,
            breadcrumbPages,
            tabItems,
        }
    }
})
